import React from 'react';
import { CalendarClock, BadgeCheck, Lock, Hourglass, Power } from 'lucide-react';
import { formatDate } from '../../lib/dateUtils';

const Line = ({ v, role }) => {
  if (v.disabled) return <span className="text-red-700 flex items-center gap-1"><Power className="w-4 h-4" /> Switched off by IT</span>;
  if (v.plan_active) {
    const byOp = role === 'driver' && v.paid_by_role === 'transport';
    return (
      <span className="text-emerald-700 flex items-center gap-1 flex-wrap">
        <BadgeCheck className="w-4 h-4" /> Yearly plan active until {formatDate(v.plan_expires_at)} ({v.plan_days_left} days)
        {byOp && <strong className="ml-1" data-testid={`paid-by-operator-${v.registration_number}`}>· Paid by your Transport Operator</strong>}
      </span>
    );
  }
  if (v.trial_on_this) return <span className="text-sky-700 flex items-center gap-1"><Hourglass className="w-4 h-4" /> Free trial on this vehicle</span>;
  return <span className="text-muted-foreground flex items-center gap-1"><Lock className="w-4 h-4" /> {v.lock_reason}</span>;
};

export const VehicleStatusList = ({ status }) => (
  <section className="space-y-2" data-testid="finance-vehicle-status">
    {status.trial.active && (
      <div className="rounded-2xl bg-sky-50 border border-sky-200 p-4 flex items-center gap-3" data-testid="trial-days-left">
        <CalendarClock className="w-6 h-6 text-sky-700" />
        <p className="text-sm text-sky-900"><strong className="text-lg">{status.trial.days_left} day(s) left</strong> in your free trial for {status.trial.registration_number} (ends {formatDate(status.trial.ends_at)}).</p>
      </div>
    )}
    {status.trial.used && !status.trial.active && (
      <p className="text-sm text-muted-foreground" data-testid="trial-ended-note">Your free trial {status.trial.ended_early ? `was ended early by the IT Administrator on ${formatDate(status.trial.ended_early_at)}` : `ended on ${formatDate(status.trial.ends_at)}`}.</p>
    )}
    {status.vehicles.map((v) => (
      <div key={v.vehicle_id} className="bg-white border rounded-xl px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 text-sm" data-testid={`vehicle-status-${v.registration_number}`}>
        <span className="font-semibold w-32">{v.registration_number}</span>
        <Line v={v} role={status.role} />
        {v.pending_payments > 0 && <span className="text-amber-700 text-xs sm:ml-auto" data-testid={`vehicle-pending-${v.registration_number}`}>Payment waiting for IT to confirm</span>}
      </div>
    ))}
  </section>
);
